export default __webpack_public_path__ + "static/media/imageLogo.a18a1d6c.png";